module.exports = __webpack_public_path__ + "static/media/ic_theme_production.a0d5e46e.svg";